import React, { useState } from "react";
import axios from "axios";
import { isValidEmail } from "@tomocredit/common-fe/utils";
import { useLocation } from "react-router-dom";
import TomoLogoBlk from "assets/tomo_logo_black.svg";
import { withNotification } from "components/common";
import { MESSAGE_TEXT, ResetForm } from "./LoginHelper";

const performPasswordRecovery = (
  email,
  setLoading,
  setErrorMessage,
  setSuccessMessage,
) => {
  setLoading(true);
  setErrorMessage("");
  setSuccessMessage("");
  axios
    .post(`${process.env.REACT_APP_BACKEND_URL}/passwordrecovery`, {
      email,
    })
    .then((response) => {
      if (response.data?.setup) {
        setErrorMessage(MESSAGE_TEXT.PASSWORD_RESET_ACCOUNT_NOT_SETUP);
        return;
      }
      setSuccessMessage(MESSAGE_TEXT.PASSWORD_RESET_PROCESS_SUCCESS);
    })
    .catch((error) => {
      const errorUserMessage = error.response?.data?.userMessage;
      setErrorMessage(errorUserMessage || MESSAGE_TEXT.PASSWORD_RESET_PROCESS_ERROR);
    })
    .finally(() => {
      setLoading(false);
    });
};

const PasswordRecovery = () => {
  // const queryParams = useQueryParams();
  // const [fromBoost] = useState(queryParams.get("fromBoost") || false);
  const location = useLocation();
  const prefilledEmail = location.state?.email || "";
  const [email, setEmail] = useState(prefilledEmail);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const validateEmailAddress = (formattedEmail) => {
    setErrorMessage("");
    if (!isValidEmail(formattedEmail)) {
      setErrorMessage(MESSAGE_TEXT.EMAIL_INVALID);
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    const formattedEmail = (email || "").trim().toLowerCase();
    if (validateEmailAddress(formattedEmail)) {
      performPasswordRecovery(
        formattedEmail,
        setLoading,
        setErrorMessage,
        setSuccessMessage,
      );
    }
  };

  return (
    <div
      className="flex h-screen w-screen outerContainer overflow-scroll bg-neutral-50"
      style={{ letterSpacing: 0.1, minWidth: 350 }}
    >
      <div className="flex justify-center items-center w-full">
        <div
          className="w-full"
          style={{ maxWidth: 400 }}
        >
          <div className="flex justify-center items-center">
            <span className="font-extrabold text-3xl">Reset password</span>
            <div className="border-r border-neutral-300 mx-4" style={{ width: 1, height: 31 }} />
            <span>
              <img src={TomoLogoBlk} alt="" style={{ height: 26, width: "auto" }} />
            </span>
          </div>
          <ResetForm
            email={email}
            setEmail={setEmail}
            handleSubmit={handleSubmit}
            loading={loading}
            errorMessage={errorMessage}
            successMessage={successMessage}
          />
        </div>
      </div>
    </div>
  );
};

export default withNotification(PasswordRecovery);
